<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th></th>
                <th v-for="worktype in worktypes">
                    {{ worktype.name }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="wagetype in wagetypes">
                <td>{{  wagetype.description }}</td>
                <td v-for="worktype in worktypes">
                    <div v-if="hasExternalId(wagetype, worktype.id) !== false">
                    <input type="number" :value="hasExternalId(wagetype, worktype.id)" @change="saveExternalId(wagetype, worktype.id, $event.target.value)">
                </div>
                <div v-else>
                    <button class="btn btn-light" @click="addWorktype(wagetype, worktype)">+</button>
                </div>
                 
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

import getWagetypes from '../composables/Wagetypes';
import getWorktypes from '../composables/Worktypes';

export default {
    name: "WagetypeWorktype",
    setup() {
        const { wagetypes, wagetypes_error, loadWagetypes, saveWagetype } = getWagetypes();
        loadWagetypes();

        const { worktypes, worktypes_error, loadWorktypes } = getWorktypes();
        loadWorktypes();

        return {
            wagetypes,
            wagetypes_error,
            loadWagetypes,
            saveWagetype,
            worktypes,
            worktypes_error,
        };
    },
    methods: {
        hasExternalId(wagetype, worktypeId) {
             const worktype = wagetype.worktypes.find( (item) => {
                return item.id == worktypeId;
             });

             if (worktype) {
                return worktype.pivot.external_id;
             }
             return false;
        },
        saveExternalId(wagetype, worktypeId, externalId) {
            var worktypeIds = [];
            var externalIds = [];

             for(var worktype of wagetype.worktypes) {
                if (worktype.id == worktypeId) {
                    worktype.pivot.external_id = parseInt(externalId);
                }

                if (! isNaN(worktype.pivot.external_id) && worktype.pivot.external_id !== null) {
                    worktypeIds.push(worktype.id);
                    externalIds.push(worktype.pivot.external_id);
                    console.log(worktype.id, worktype.pivot.external_id);
                }
             }
             this.saveWagetype(wagetype.id, worktypeIds, externalIds);
             wagetype.worktypes = wagetype.worktypes.filter( (item) => (! isNaN(item.pivot.external_id) && item.pivot.external_id !== null) );
            },
        addWorktype(wagetype, worktype) {
            var newWorktype = {... worktype};
            newWorktype.pivot = {
                 external_id: null,
                 id: -1
                };
            wagetype.worktypes.push(newWorktype);
            // this.$forceUpdate(); 
        }
    }
}
</script>

<style></style>